import React, { FC, KeyboardEvent } from 'react';
import styles from './ToggleSwitch.module.css';

export interface ToggleSwitchProps {
    id: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    name?: string;
    ariaLabel?: string;
    optionLabels?: [string, string];
    optionIcons?: [string, string];
    small?: boolean;
    disabled?: boolean;
}

export const ToggleSwitch: FC<ToggleSwitchProps> = ({
    id,
    checked,
    onChange,
    name,
    ariaLabel,
    optionLabels = ['ON', 'OFF'],
    optionIcons,
    small = false,
    disabled = false,
}) => {
    const handleKeyPress = (e: KeyboardEvent<HTMLLabelElement>) => {
        if (disabled || (e.key !== ' ' && e.key !== 'Enter')) return;
        e.preventDefault();
        onChange(!checked);
    };


    return (
        <div className={`${styles['toggle-switch']} ${small ? styles['small-switch'] : ''}`}>
            <input
                type="checkbox"
                name={name}
                className={styles['toggle-switch-checkbox']}
                id={id}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
            />
            {id && (
                <label
                    className={styles['toggle-switch-label']}
                    tabIndex={disabled ? -1 : 0}
                    onKeyDown={handleKeyPress}
                    htmlFor={id}
                    role="switch"
                    aria-label={ariaLabel}
                    aria-describedby={optionIcons ? `${id}-selected-view` : undefined}
                    title={optionIcons ? optionLabels[checked ? 0 : 1] : undefined}
                    aria-checked={checked}
                    aria-disabled={disabled}>
                    <span
                        className={`${styles['toggle-switch-inner']} ${disabled ? styles['toggle-switch-disabled'] : ''}`}
                        data-yes={optionIcons ? '' : optionLabels[0]}
                        data-no={optionIcons ? '' : optionLabels[1]}
                    />
                    {optionIcons && (
                        <i
                            className={`${optionIcons[checked ? 0 : 1]} position-absolute top-50 translate-middle-y ${checked ? 'start-0' : 'end-0'} mx-2 text-white`}
                            aria-hidden="true"
                        />
                    )}
                    <span className={`${styles['toggle-switch-switch']} ${disabled ? styles['toggle-switch-disabled'] : ''}`} />
                </label>
            )}
            {optionIcons && (
                <span id={`${id}-selected-view`} className="visually-hidden">
                    {optionLabels[checked ? 0 : 1]}
                </span>
            )}
        </div>
    );
};
